module.exports = __webpack_public_path__ + "static/media/Mission Giga Logo (1) (1).d85dc588.png";